import React from "react";

import classnames from "classnames/dedupe";

import "./busy-overlay.styles.scss";

interface IBusyOverlay {
    isBusy: boolean;
    children: Children;
}

export const BusyOverlay = ({ isBusy, children }: IBusyOverlay) => {
    return (
        <div className="busy-overlay-container">
            <div className={classnames("busy-overlay", { busy: isBusy })} />
            {children}
        </div>
    );
};
